<div class="overlay3"
     (click)="onClose()"></div>

<div class="popup-wrap" [@wordDetailInOut]>

  <div class="popup-head">
    <div class="head-txt-box">도움말</div>
    <a class="popup-close-btn" (click)="onClose()"></a>
  </div>

  <div class="pitch-help-body-container scroll-effect"
       [style.max-height.px]="calculatedHeight">
    <div class="popup-body">

      <div class="help-txt-box">
        <div class="row">
          <div class="subject">음성 고저장단 표시선</div>
          <div class="con">'나의 말 소리'를 눈으로 보게 하는 표시선으로 자신의 고저장단과 비교해 봅시다.<br>
            선의 모양이 유사하면 성공!</div>
        </div>
      </div>
    </div>
  </div>

  <div class="question-box">
    <div class="question-txt">마이크가 정상으로 작동하지 않을 때</div>
    <div class="question-btn-box">
      <a class="question-btn type1"
         [routerLink]="['/board', BBS_CATEGORY.USAGE, RECORDER_HELP_BBS_ID]">마이크 설정 도움</a>
    </div>
  </div>
</div>
